module.exports = __webpack_public_path__ + "media/images/home_logo_2-7dbade23c3e59b1756cbaf56761b2e04.png";